import { connect } from 'react-redux';
import Calendar from './Calendar';
import {
    applyEventFilters,
    mergeInspectorPackDocumentsBegin,
    getCalendarSearchConfiguredFormBegin,
    setCalendarFilterSelections,
} from '../../store/actions/calendar.actions';
import { setError } from '../../store/actions/site.actions';
import {
    getCalendarEvents,
    getEventListLoading,
    getLoadMore,
    getFilteredEventListLoading,
    getInspectorPackLoading,
    getCalendarSearchForm,
    getCalendarSearchFormLoadingStatus,
    getCalendarFilterSelections,
} from '../../store/selectors/calendar.selectors';
import { getMergeTemplatesBegin } from '../../store/actions/license.actions';
import { getCalendarColumnFields } from '../../store/selectors/site.selectors';
import { getMergeTemplatesList } from '../../store/selectors/license.selectors';

const mapStateToProps = (state: any) => {
    const eventList = getCalendarEvents(state);
    const isLoading = getEventListLoading(state);
    const hasMore = getLoadMore(state);
    const isFiltersLoading = getFilteredEventListLoading(state);
    const mergeTemplatesList = getMergeTemplatesList(state);
    const templateLoading = getInspectorPackLoading(state);
    const isSearchFormLoading = getCalendarSearchFormLoadingStatus(state);
    const searchForm = getCalendarSearchForm(state);
    const filterSelections = getCalendarFilterSelections(state);
    const calendarColumnFields = getCalendarColumnFields(state);
    return {
        eventList,
        isLoading,
        hasMore,
        isFiltersLoading,
        mergeTemplatesList,
        templateLoading,
        isSearchFormLoading,
        searchForm,
        filterSelections,
        calendarColumnFields,
    };
};

const mapDispatchToProps = {
    setError,
    applyEventFilters,
    getMergeTemplates: getMergeTemplatesBegin,
    mergeInspectorPackDocuments: mergeInspectorPackDocumentsBegin,
    getSearchForm: getCalendarSearchConfiguredFormBegin,
    setFilterSelections: setCalendarFilterSelections,
};

export default connect(mapStateToProps, mapDispatchToProps)(Calendar);
